const state = {
    hotelLs: null,
    selHotelLs:null,
    appHotelLs:null,
    allEnums:null,
};

const getters = {
    GET_HOTEL_LS: (state) => {
        return state.hotelLs;
    },
    GET_APPLY_HOTEL_LS: (state) => {
        return state.appHotelLs;
    },
    GET_SEL_HOTEL: (state) => {
        return state.selHotelLs;
    },
    GET_ALL_ENUMS: (state) => {
        return state.allEnums;
    },

   GET_SURCHARGE_PRICING:(state)=>{
    if(state.allEnums)
        return state.allEnums.surchargePriceType
    },

    GET_RATE_PLAN_PRICING:(state)=>{
        if(state.allEnums)
        return state.allEnums.ratePlanPriceType
    },

    GET_TAX_MODE:(state)=>{
        if(state.allEnums)
        return state.allEnums.taxMode
    },

    GET_TAX_TYPE:(state)=>{
        if(state.allEnums)
        return state.allEnums.taxType
    },
    GET_GUEST_TYPE:(state)=>{
        if(state.allEnums)
        return state.allEnums.hmsPaxType
    },


    GET_HOTEL_COND:(state)=>{

          if(state.allEnums)
        return  state.allEnums.hotelCondition
    },


        GET_HOTEL_ERROR_TYPE:(state)=>{
            if(state.allEnums)
            return  state.allEnums.HotelErrorType
        },
        

        GET_HOTEL_ERROR_CATEGORY:(state)=>{
            if(state.allEnums)
            return state.allEnums.HotelErrorCategory
        },


        GET_WEEK_DAYS:(state)=>{
            if(state.allEnums)
            return state.allEnums.weekDays
        }
        
};


const actions = {

    CLEAR_HOTEL_STORE: ({ commit }) => {
        commit('clearHotelLsStore');
    },
    SET_HOTEL_LS: ({ commit }, suppGrp) => {

        commit('saveHotelLs', suppGrp);

    },
    SET_APPLY_HOTEL_LS: ({ commit }, appHotelLs) => {

        commit('saveApplyHotelLs', appHotelLs);

    },
    SET_SEL_HOTEL: ({ commit }, selHotelLs) => {

        commit('saveSelHotelLs', selHotelLs);

    },
    SET_ALL_ENUMS: ({ commit }, enums) => {

        commit('saveAllEnums', enums);

    },

};


const mutations = {
    clearHotelLsStore: (state) => {
        state.hotelLs = null;
       state.selHotelLs = null;
       state.appHotelLs = null;
       state.allEnums = null;

    },

    saveHotelLs: (state, routes) => {
        state.hotelLs = routes;
    },

    saveApplyHotelLs: (state, appHotelLs) => {
        state.appHotelLs = appHotelLs;
    },

    saveSelHotelLs: (state, selHotelLs) => {
        state.selHotelLs = selHotelLs;
    },
    saveAllEnums: (state, enums) => {
        state.allEnums = enums;
    },

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}